import { render, staticRenderFns } from "./programForm.vue?vue&type=template&id=0b37d3df&scoped=true"
import script from "./programForm.vue?vue&type=script&lang=js"
export * from "./programForm.vue?vue&type=script&lang=js"
import style0 from "./programForm.vue?vue&type=style&index=0&id=0b37d3df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37d3df",
  null
  
)

export default component.exports